import Component from './Component';
import { hasError, showError, removeError, handleEvents, focus } from './../services/FormValidation';
import { togglePreloader } from './../services/ScrollResizeHandler';
/**
 * --------------------------------------------------------------------------------------------
 * PRIVATE VARIABLES
 * --------------------------------------------------------------------------------------------
 */


/**
 * --------------------------------------------------------------------------------------------
 * HELPER FUNCTIONS
 * --------------------------------------------------------------------------------------------
 */


/**
 * --------------------------------------------------------------------------------------------
 * EXPORTS
 * --------------------------------------------------------------------------------------------
 */

export default class ProjectOverview extends Component {

    decorator() {
        return {
            selector: '.js-form-overview-add-more-project',
            name: 'ProjectOverview',
        }
    }

    constructor(element) {
        super(element);
        this.bind();
    }

    bind() {
        this.$form = document.querySelectorAll('form#application_form');
        this.$formElements = this.$form[0].elements;
        this.project_items = 'section.s-application-form div.s-question__body fieldset.js-project-item';
        this.remove_btn = '.js-question-project-item-remove';
        this.project_max_count = 3;
        let self = this,
            clone_selector = 'form .s-question__body fieldset.js-project-item',
            $clone = $(clone_selector).clone();
            $clone.find('.js-project-name input').val('');
            $clone.find('.select2').remove();

        if($(clone_selector).find('.select2-container').length === 0) {
            $(clone_selector).find('select').select2();
            self.prepSelect2($(clone_selector));
        }

        self.$element.off().on('click', function () {
            if ($(self.project_items).length < self.project_max_count) {
                var clone = $clone.clone();
                $(self.project_items).parent().append(clone);
                $(clone).find('select').select2();
                self.resetCloneIndex();
                self.prepSelect2($(clone));
                self.bindRemoveBtn($(clone).find(self.remove_btn));
            }

        });

        $(this.project_items).each(function (index) {
            self.bindRemoveBtn($(this).find(self.remove_btn));
        });

        this.bindForm();
    }

    prepSelect2(el) {
        el.find('.select2-container--default').addClass('select2-container--white').removeClass('select2-container--default');
        el.find('.select2-container').on('click', function() {
            el.find('.o-select').toggleClass('is-active');
        });
    }

    bindForm() {
        this.$form[0].addEventListener('submit', e => {
            e.preventDefault();

            const fields = e.target.elements;

            let error,
                hasErrors;


            for (let i = 0; i < fields.length; i++) {
                error = hasError(fields[i]);

                if (error) {
                    showError(this.$formElements, fields[i], error);

                    if (!hasErrors) {
                        hasErrors = fields[i];
                    }
                }

                if (hasErrors) {
                    hasErrors.focus();
                }
            }

            if (typeof hasErrors != 'undefined') { return; }

            // togglePreloader();
            this.$form[0].submit();
        });


        handleEvents(this.$formElements);
    }

    bindRemoveBtn($el) {
        let self = this;
        $el.off().on('click', function(e) {
            e.preventDefault();
            if($(self.project_items).length > 1) {
                $(this).closest('.js-project-item').remove();
                self.resetCloneIndex();
            }
        });
    }

    resetCloneIndex() {
        $(this.project_items).each(function (index) {
            $(this).find('.js-project-name label').attr('for', 'project_name_' + index);
            $(this).find('.js-project-name label').text('Project #' + (index + 1));
            $(this).find('.js-project-name input').attr('id', 'project_name_' + index);
            $(this).find('.js-project-name input').attr('name', 'project[' + index + '][name]');
            $(this).find('.js-project-form label').attr('for', 'project_form_' + index);
            $(this).find('.js-project-form select').attr('id', 'project_form_' + index);
            $(this).find('.js-project-form select').attr('name', 'project[' + index + '][form]');
        });

        if($(this.project_items).length == this.project_max_count) {
            this.$element.css({display: 'none'});
        } else {
            this.$element.css({display: 'inline'});
        }

        let removeBtns = $(this.project_items + ' ' + this.remove_btn);
        if(removeBtns.length === 1) {
            $(this.project_items + ' ' + this.remove_btn).addClass('hide');
        } else {
            removeBtns.each(function() {
                $(this).removeClass('hide');
            });
        }
    }

}
